module.exports = __webpack_public_path__ + "img/consultoria_4-3_682.3a3789c1.jpg";